import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import icon_check from "@assets/img/icon_check_cotizador.svg";

interface ButtonTypeProps {
  isSelected: boolean;
  onClick?: () => void;
  title: string;
}

const ButtonTypeSelectedV2: React.FC<ButtonTypeProps> = ({ isSelected, onClick, title }) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      {isSelected && (
        <Box
          component="img"
          src={icon_check}
          alt="Seleccionado"
          sx={{
            position: "absolute",
            top: "-10px",
            left: "calc(50% - 12px)",
            borderRadius: "50%",
            zIndex: 2,
            width: 22,
            height: 22,
          }}
        />
      )}
      <Button
        onClick={onClick}
        sx={(theme) => ({
          position: "relative",
          zIndex: 1,
          width: isMobileOrTablet ? "170px" : "200px",
          height: isMobileOrTablet ? "60px" : "80px",
          borderRadius: "5px",
          backgroundColor: isSelected ? theme.palette.primary.dark : theme.palette.primary.main,
          color: "#FFFFFF",
          border: isSelected ? `2px solid ${theme.palette.primary.accent}` : "none",
          boxShadow: isSelected ? "2px 4px 10px rgba(200, 150, 150, 0.4)" : "none",
          textTransform: "none",
          fontSize: isMobileOrTablet ? "11px" : "14px",
          fontWeight: 400,
          lineHeight: isMobileOrTablet ? "16px" : "20px",
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            color: "#FFFFFF",
          },
        })}
      >
        {title}
      </Button>
    </Box>
  );
};

export default ButtonTypeSelectedV2;
